import { render, staticRenderFns } from "./OrganizationLeadList.vue?vue&type=template&id=40119e52&"
import script from "./OrganizationLeadList.vue?vue&type=script&lang=js&"
export * from "./OrganizationLeadList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports